<script>

import SpinnerIndicator from "@js/components/Statuses/SpinnerIndicator.vue";

export default {
    name: "CatalogFilterBlockLoading",
    components: {SpinnerIndicator}
}
</script>

<template>
    <div class="animate-pulse space-y-4">
        <!-- Ползунок (имитация VueSlider) -->
        <div class="h-3 bg-gray-300 rounded-full w-full"></div>

        <!-- Два инпута -->
        <div class="grid grid-cols-2 gap-5 mt-4">
            <div class="flex flex-col space-y-2">
                <div class="h-5 bg-gray-300 rounded w-1/2"></div> <!-- Лейбл -->
                <div class="h-10 bg-gray-300 rounded w-full"></div> <!-- Поле ввода -->
            </div>
            <div class="flex flex-col space-y-2">
                <div class="h-5 bg-gray-300 rounded w-1/2"></div> <!-- Лейбл -->
                <div class="h-10 bg-gray-300 rounded w-full"></div> <!-- Поле ввода -->
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
